import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    component: () => import('@/views/Main.vue'),
    children: [
      {
        name: 'home',
        path: '',
        component: () => import('@/layouts/Home.vue'),
        meta: {
          title: 'Mark 5 Music - Home'
        }
      },
      {
        name: 'artists.artistslug',
        path: '/artists/:artistSlug',
        component: () => import('@/layouts/ArtistDetails.vue'),
        props: true,
        meta: {
          title: 'Mark 5 Music - Artists'
        }
      },
      {
        name: 'artists.artistslug.itemtype.itemslug',
        path: '/artists/:artistSlug/:itemType/:itemSlug',
        component: () => import('@/layouts/ArtistDetails.vue'),
        props: true,
        meta: {
          title: 'Mark 5 Music - Artists'
        }
      }, 
    ]
  },
  {
    name: 'notfound',
    path: '/:pathMatch(.*)',
    component: () => import('@/components/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((toRoute, fromRoute, next) => {
  document.title = toRoute.meta.title + (toRoute.params?.artistSlug ? ` - ${toRoute.params.artistSlug.replace(/(^\w)/g, g => g[0].toUpperCase()).replace(/([-_]\w)/g, g => " " + g[1].toUpperCase()).trim()}` : '');
  next();
})

export default router
